import { useState, useEffect } from 'react';
const ImageRender = (props) => {
    let { src, ...otherProps } = props;
    const [webpSrc, setWebpSrc] = useState(null);
    useEffect(() => {
        let isUrlImgReg = /^https?:\/\//i;
        if (src && !isUrlImgReg.test(src)) {
            const webpSrc = src.replace(/\.(png|jpe?g)$/i, '.webp');
            setWebpSrc(webpSrc);
        } else {
            setWebpSrc(`${src}?x-oss-process=image/format,webp`);
        }
    }, [src]);
    return (
        <>
            <picture style={{ display: 'contents' }}>
                <source srcSet={webpSrc} type="image/webp" />
                <img loading="lazy" decoding="async" {...otherProps} src={src} alt="" />
            </picture>
        </>
    );
};

export default ImageRender;
